import Button from '@components/Button/Button';
import { Overline, Subtitle2 } from '@components/Texts/Texts';
import tw, { styled } from 'twin.macro';

export const GetOrderContainer = styled.div`
  ${tw`p-2`}
`;

export const GetOrderInfoItem = styled.div`
  ${tw`w-1/2`};
`;

export const InfoTitle = styled(Overline)`
  ${tw`text-light-low`};
`;

export const InfoValue = styled(Subtitle2)`
  ${tw`text-light-medium`};
`;

export const GetOrderInfoWrapper = styled.div`
  ${tw`flex flex-row`}
`;

export const GetOrderButton = styled(Button)`
  ${tw`mt-4 items-center flex justify-center`};
`;
